'use client';

import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';

type ISpinnerContextProvider = {
  children: ReactNode;
};

type ISpinnerContext = {
  startLoaderEvent: Event;
  stopLoaderEvent: Event;
};

export const SpinnerContext = createContext({} as ISpinnerContext);

export function useSpinnerContext() {
  return useContext(SpinnerContext);
}

export function SpinnerContextProvider({ children }: ISpinnerContextProvider) {
  const [events, setEvents] = useState<any>();
  useEffect(() => {
    const startLoaderEvent = new CustomEvent('startLoading');

    const stopLoaderEvent = new CustomEvent('stopLoading');
    setEvents({ startLoaderEvent, stopLoaderEvent });
  }, []);

  return (
    <SpinnerContext.Provider
      value={{
        startLoaderEvent: events && events.startLoaderEvent,
        stopLoaderEvent: events && events.stopLoaderEvent,
      }}
    >
      {children}
    </SpinnerContext.Provider>
  );
}
